/**
 * Utilitários para tradução de mensagens de erro
 * Converte mensagens técnicas do Supabase em chaves de tradução
 */

import { getServerTranslations, createServerTranslator, getLocale } from '../../../lib/i18n'

// Mapeamento de erros para chaves de tradução
export const authErrorKeys: { [key: string]: string } = {
  // Erros de Login
  'Invalid login credentials': 'errors.invalidLoginCredentials',
  'Email not confirmed': 'errors.emailNotConfirmed',
  'User not found': 'errors.userNotFound',
  
  // Erros de Cadastro
  'User already registered': 'errors.userAlreadyRegistered',
  'Email rate limit exceeded': 'errors.emailRateLimitExceeded',
  
  // Erros de Validação - Email
  'Invalid email': 'errors.invalidEmail',
  
  // Erros de Validação - Senha
  'Password should be at least 6 characters': 'errors.passwordTooShort',
  'Signup requires a valid password': 'errors.signupRequiresPassword',
  'Password should contain at least one uppercase letter, one number, and one special character': 'errors.passwordWeak',
  'Password too weak': 'errors.passwordWeak',
  'Password is too common': 'errors.passwordCommon',
  'Password used too often': 'errors.passwordUsedOften',
  
  // Erros de Rede
  'Failed to fetch': 'errors.failedToFetch',
  'NetworkError': 'errors.networkError',
}

/**
 * Traduz mensagens de erro do Supabase para mensagens amigáveis internacionalizadas (client-side)
 * @param errorMessage - Mensagem de erro original
 * @param t - Função de tradução do contexto
 * @returns Mensagem traduzida e amigável
 */
export function getAuthErrorMessage(
  errorMessage: string,
  t: (key: string) => string
): string {
  if (!errorMessage) return t('errors.defaultError')

  // Procura por mensagens que contenham as chaves
  for (const [key, translationKey] of Object.entries(authErrorKeys)) {
    if (errorMessage.includes(key)) {
      return t(translationKey)
    }
  }

  // Se não encontrou nenhuma correspondência, retorna a mensagem padrão
  return t('errors.defaultError')
}

/**
 * Traduz mensagens de erro do Supabase para mensagens amigáveis internacionalizadas (server-side)
 * @param errorMessage - Mensagem de erro original
 * @param locale - Locale opcional (padrão: locale do ambiente)
 * @returns Promise com mensagem traduzida e amigável
 */
export async function getAuthErrorMessageServer(
  errorMessage: string,
  locale?: string
): Promise<string> {
  const translations = await getServerTranslations(locale)
  const { t } = createServerTranslator(translations)
  
  if (!errorMessage) return t('errors.defaultError')

  // Procura por mensagens que contenham as chaves
  for (const [key, translationKey] of Object.entries(authErrorKeys)) {
    if (errorMessage.includes(key)) {
      return t(translationKey)
    }
  }

  // Se não encontrou nenhuma correspondência, retorna a mensagem padrão
  return t('errors.defaultError')
}
